import React from 'react';

function Zimbabwe(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123953)">
        <mask
          id="mask0_800_123953"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123953)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_123953"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123953)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 2V22H36V2H0Z"
              fill="#FECA00"
            />
            <path
              d="M0 8.25H-1.75V10V14V15.75H0H36H37.75V14V10V8.25H36H0Z"
              fill="#272727"
              stroke="#E31D1C"
              strokeWidth="3.5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 4V0H36V4H0ZM0 24V20H36V24H0Z"
              fill="#5EAA22"
            />
          </g>
          <path
            d="M0.551663 -0.834067L-1 -1.86036V0V24V25.8348L0.541955 24.8404L18.9147 12.9924L20.2014 12.1626L18.9244 11.3179L0.551663 -0.834067Z"
            fill="#F7FCFF"
            stroke="#272727"
            strokeWidth="2"
          />
          <mask
            id="mask2_800_123953"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="-2"
            y="-4"
            width="25"
            height="32"
          >
            <path
              d="M0.551663 -0.834067L-1 -1.86036V0V24V25.8348L0.541955 24.8404L18.9147 12.9924L20.2014 12.1626L18.9244 11.3179L0.551663 -0.834067Z"
              fill="white"
              stroke="white"
              strokeWidth="2"
            />
          </mask>
          <g mask="url(#mask2_800_123953)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.41321 14.2783L4.16191 17.3287L6.11195 13.2521L2.76123 10.3839H6.71629L8.33919 6.92505L10.0629 10.3839H14.0112L10.4835 13.2521L12.249 17.3287L8.41321 14.2783Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.64468 8.42151C5.64468 8.42151 5.58297 8.28925 5.94727 8.17231C6.31157 8.05537 6.42269 7.80758 6.70827 7.98995C6.99385 8.17231 7.1725 7.80567 7.25444 8.33153C7.33638 8.8574 7.56222 9.68662 7.56222 9.68662L11.2607 12.1573H10.5658C10.5658 12.1573 9.48377 13.5705 9.66243 14.8104C9.66243 14.8104 8.91583 14.7095 7.90388 14.7095C6.89193 14.7095 6.22913 14.925 6.22913 14.925L5.64468 13.0014C5.64468 13.0014 5.8563 12.6782 5.94727 12.4177C6.03823 12.1573 6.4149 12.1092 6.4149 11.902C6.4149 11.6948 6.04337 11.5211 6.22913 10.9848C6.4149 10.4484 6.4149 8.84406 6.4149 8.84406C6.4149 8.84406 5.82779 8.61457 5.94727 8.61457C6.06674 8.61457 6.33908 8.42151 6.14318 8.42151C5.94727 8.42151 5.64468 8.42151 5.64468 8.42151Z"
              fill="#FECA00"
            />
            <path
              d="M7.56222 9.68662L7.44161 9.71947L7.4539 9.76459L7.49278 9.79056L10.8486 12.0323H10.5658H10.5041L10.4666 12.0813L10.5658 12.1573L10.4665 12.0814L10.4665 12.0814L10.4663 12.0817L10.4655 12.0827L10.4629 12.0862L10.4533 12.0991C10.4449 12.1103 10.433 12.1267 10.4179 12.1479C10.3877 12.1903 10.3451 12.2518 10.2947 12.3294C10.194 12.4844 10.0617 12.7043 9.93482 12.964C9.70368 13.4374 9.48274 14.0597 9.52209 14.668C9.4364 14.6588 9.31797 14.6471 9.17268 14.6353C8.85695 14.6099 8.41389 14.5845 7.90388 14.5845C7.38912 14.5845 6.96277 14.6393 6.66435 14.6943C6.5151 14.7219 6.39772 14.7495 6.31713 14.7704C6.31578 14.7707 6.31443 14.7711 6.3131 14.7714L5.78094 13.0199C5.78241 13.0175 5.78392 13.0151 5.78547 13.0126C5.80738 12.9771 5.83752 12.9272 5.8706 12.8689C5.93593 12.7537 6.01602 12.6 6.06528 12.459C6.09459 12.375 6.17135 12.3195 6.28461 12.2439L6.28796 12.2416C6.33737 12.2086 6.39755 12.1685 6.44417 12.1206C6.4949 12.0685 6.5399 11.9971 6.5399 11.902C6.5399 11.8139 6.50054 11.739 6.46725 11.6829C6.45306 11.659 6.43982 11.6381 6.42713 11.6181C6.40505 11.5832 6.3846 11.5509 6.36367 11.51C6.30763 11.4003 6.26678 11.258 6.34725 11.0257C6.39845 10.8779 6.43443 10.6655 6.4607 10.4384C6.48726 10.2088 6.50484 9.95499 6.51653 9.71949C6.52822 9.48375 6.53406 9.26508 6.53698 9.10541C6.53844 9.02553 6.53917 8.96034 6.53953 8.91505L6.53985 8.86268L6.53989 8.84891L6.5399 8.84533L6.5399 8.8444L6.5399 8.84416V8.84409L6.4149 8.84406H6.5399V8.75871L6.46041 8.72763L6.46041 8.72763L6.4604 8.72763L6.46033 8.7276L6.46005 8.72749L6.45886 8.72703L6.45411 8.72516L6.43599 8.718L6.37191 8.69232C6.32908 8.67499 6.27575 8.65309 6.22263 8.63041C6.22968 8.62518 6.23649 8.61986 6.24301 8.61448C6.26213 8.59872 6.28228 8.57958 6.29875 8.55764C6.3126 8.53918 6.33743 8.50114 6.33701 8.45063C6.33677 8.42214 6.32834 8.39254 6.30969 8.36651C6.29186 8.34163 6.26925 8.32629 6.24971 8.31698C6.21358 8.29975 6.17423 8.29651 6.14318 8.29651H6.14203H6.14087H6.13972H6.13856H6.13741H6.13624H6.13508H6.13392H6.13275H6.13158H6.1304H6.12923H6.12805H6.12687H6.12569H6.12451H6.12332H6.12213H6.12095H6.11975H6.11856H6.11736H6.11616H6.11496H6.11376H6.11256H6.11135H6.11014H6.10893H6.10772H6.10651H6.10529H6.10407H6.10285H6.10163H6.10041H6.09919H6.09796H6.09673H6.0955H6.09427H6.09304H6.0918H6.09056H6.08933H6.08808H6.08684H6.0856H6.08436H6.08311H6.08186H6.08061H6.07936H6.07811H6.07685H6.0756H6.07434H6.07308H6.07183H6.07056H6.0693H6.06804H6.06677H6.06551H6.06424H6.06297H6.0617H6.06043H6.05916H6.05789H6.05661H6.05534H6.05406H6.05278H6.0515H6.05022H6.04894H6.04766H6.04637H6.04509H6.04381H6.04252H6.04123H6.03994H6.03866H6.03737H6.03608H6.03478H6.03349H6.0322H6.0309H6.02961H6.02831H6.02702H6.02572H6.02442H6.02312H6.02183H6.02053H6.01923H6.01792H6.01662H6.01532H6.01402H6.01272H6.01141H6.01011H6.0088H6.0075H6.00619H6.00489H6.00358H6.00227H6.00097H5.99966H5.99835H5.99704H5.99573H5.99443H5.99312H5.99181H5.9905H5.98919H5.98788H5.98657H5.98526H5.98395H5.98264H5.98133H5.98002H5.9787H5.97739H5.97608H5.97477H5.97346H5.97215H5.97084H5.96968C5.97482 8.29479 5.98008 8.29306 5.98547 8.29133C6.08726 8.25866 6.17044 8.21708 6.24053 8.17804C6.27109 8.16101 6.29656 8.1461 6.31946 8.13268C6.3534 8.1128 6.3817 8.09623 6.41258 8.081C6.45878 8.05821 6.49039 8.04976 6.51881 8.05006C6.546 8.05034 6.5839 8.05884 6.64099 8.0953C6.79738 8.19517 6.95462 8.17189 7.02903 8.16088C7.04325 8.15877 7.05445 8.15712 7.06204 8.15685C7.06852 8.15663 7.07254 8.15688 7.07478 8.15713C7.07505 8.15746 7.07537 8.15785 7.07572 8.15831C7.08781 8.17397 7.11089 8.22214 7.13093 8.35078C7.17276 8.61927 7.25079 8.96236 7.31763 9.23594C7.35117 9.37325 7.38213 9.49399 7.40471 9.58043C7.416 9.62366 7.4252 9.65833 7.43159 9.68224L7.43898 9.70976L7.44092 9.71694L7.44143 9.7188L7.44156 9.71928L7.4416 9.71941L7.44161 9.71945L7.56222 9.68662Z"
              stroke="#0A0A0A"
              strokeWidth="0.25"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123953">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Zimbabwe;
